import styled from "styled-components";

export const AuthInputWrapper = styled.div`
  margin-bottom: 10px;
`;

export default AuthInputWrapper;
